import { NgModule } from '@angular/core';
import { BusinessEntityTypePipe } from './business-entity-type.pipe';
import { ContractStepPipe } from './contract-step.pipe';
import { CurrencyTypePipe } from './currency-type.pipe';
import { EnumToArrayPipe } from './enum-to-array.pipe';
import { FilterPipe } from './filter.pipe';
import { PersonEntityTypePipe } from './person-entity-type.pipe';
import { BeneficiaryStatusPipe } from './beneficiary-status.pipe';
import { SafeHtml } from './safe-html.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    EnumToArrayPipe,
    ContractStepPipe,
    BusinessEntityTypePipe,
    PersonEntityTypePipe,
    CurrencyTypePipe,
    BeneficiaryStatusPipe,
    SafeHtml
  ],
  exports: [FilterPipe, EnumToArrayPipe, ContractStepPipe, BusinessEntityTypePipe, PersonEntityTypePipe, CurrencyTypePipe, BeneficiaryStatusPipe, SafeHtml],
})
export class PipesModule {}
